import { Controller } from "stimulus";
import tippy from "tippy.js";
import 'tippy.js/themes/light-border.css';
import '../styles/partials/_card-menu.scss';

export default class extends Controller {
  connect() {
    this.initializeCardProperties();
  }

  initializeCardProperties() {
    this.element.querySelectorAll('.badge.persisted').forEach((badge) => {
      tippy(badge, {
        content: badge.dataset.menuBadge,
        trigger: 'click', // mouseenter, click, focus; manual.
        placement: 'bottom',
        appendTo: document.body,
        arrow: true,
        allowHTML: true,
        theme: 'light-border',
        animation: 'scale',
        duration: [250, 200],
        interactive: true,
        delay: [100, 200]
      });
    });

    $('body').on('click', '.c-card a.c-card__menu-item', (ev) => {
      let $a = ev.currentTarget,
        tippyRoot = $a.closest('[data-tippy-root]');

      !!tippyRoot && tippyRoot._tippy.hide();
    });
  }
}